import React from "react";
import { Container } from "reactstrap";
import Moment from "moment";
import ContactLoader from "views/ContantLoader";
import { getToken } from "Utils/Common";
import "../styles.css";
import { getCompany, getPersonAnalytics } from "api/AccountsApi";

export default class AllAccount extends React.Component {
  state = {
    data: [],
    tags: [],
    dontLoad: false,
    fromdate: "",
    todate: "",
    companyName: "",
  };
  setBarSizes(d) {


    var bar1 = d.newPersonAdded;
    var bar2 = d.subscribe;

    var bar3 = d.unSubscribe;

    var x = document.getElementsByClassName("progress")[0].offsetWidth;
    var bars = document.getElementsByClassName("animate-progress");
    // bars[0].style.width=""+(0.5*x)+"px";

    var ratio = bar1 + bar2 + bar3;

    // document.getElementById("b1").style.width = ""+((this.state.data.newPersonAdded/ratio)*x)+"px";






    bars[0].style.width = "" + (bar1 / ratio) * 100 + "%";
    bars[1].style.width = "" + (bar2 / ratio) * 100 + "%";
    bars[2].style.width = "" + (bar3 / ratio) * 100 + "%";
  }
  componentDidMount() {
    const token = "Bearer " + getToken();
    const options = {
      headers: { Authorization: token },
    };
    getPersonAnalytics()
      .then((data) => {
        this.setState({ data });
        const fromdate = Moment(data.period.fromDate).format("MMM D,YYYY");
        this.setState({ fromdate });
        const todate = Moment(data.period.toDate).format("MMM D,YYYY");
        this.setState({ todate });
        let tags = data.topTags;
        this.setState({ tags });
        this.setBarSizes(data);
      })
      .catch((e) => { })
    getCompany()
      .then((data) => {
        this.setState({ companyName: data.name });
      })
      .catch((e) => { })

    window.onload = function () {
      if (
        document.querySelectorAll(".progress").length > 0 &&
        document.querySelectorAll(".progress [data-progress]").length > 0
      ) {
        document
          .querySelectorAll(".progress [data-progress]")
          .forEach((x) => AnimateProgress(x));
      }
    };
    setTimeout(() => {
      this.setState({ dontLoad: true });
    }, 10000);
    function AnimateProgress(el) {
      el.className = "animate-progress";
      el.setAttribute("style", `width:${el.getAttribute("data-progress")}%;`);
    }
  }

  render() {
    // var x=document.gdocument.getElementById('bar1').offsetWidth;
    //  const barStyle1 = {
    //   color: "white",
    //   backgroundColor: "DodgerBlue",
    //   fontFamily: "Arial",
    //   width: this.state.data.newPersonAdded,
    //   padding: (x-this.state.data.newPersonAdded)

    // };

    return (
      <>
        <div>
          <div className="page_heading">
            <h2>Contacts</h2>
            {/* <p>{this.state.companyName}</p> */}
          </div>

          <div style={{ padding: '18px 66px 55px 60px' }} className="account_list_outer">
            <div className="row" style={{ flexWrap: 'initial' }}>
              <div style={{ marginRight: '17px' }} className="eBox">
                <div className="recent_growth d-flex flex-wrap align-items-center">
                  <div className="icon tag_icon">
                    <span className="icon-growth1"></span>
                  </div>
                  <div className="growth_text">
                    <p className="font4">Recent Growth</p>
                    <p className="font7">
                      New contacts added to this audience in the last 60 days.
                    </p>
                  </div>
                </div>
                <div className="audience">
                  <ul>
                    <li className="d-flex flex-wrap align-items-center contact">
                      <div className="audience_left">
                        <p className="font-bold">New Contacts</p>
                        <div id="bar1" className="progress">
                          <div
                            // style={{ width: this.state.data.newPersonAdded }}
                            data-progress={this.state.data.newPersonAdded}
                            className="animate-progress"
                            id="b1"
                          ></div>
                        </div>
                        <p className="font7">
                          From {this.state.fromdate} to {this.state.todate}
                        </p>
                      </div>
                      <div className="audience_count font-bold">
                        {this.state.data.newPersonAdded}
                      </div>
                    </li>

                    <li className="d-flex flex-wrap align-items-center Subscribed">
                      <div className="audience_left">
                        <p className="font-bold">Subscribed</p>
                        <div className="progress">
                          <div
                            // style={{ width: this.state.data.subscribe }}
                            data-progress={this.state.data.subscribe}
                            className="animate-progress"
                          ></div>
                        </div>
                        <p className="font7">
                          From {this.state.fromdate} to {this.state.todate}
                        </p>
                      </div>
                      <div className="audience_count font-bold">
                        {this.state.data.subscribe}
                      </div>
                    </li>
                    <li className="d-flex flex-wrap align-items-center Unsubscribed">
                      <div className="audience_left">
                        <p className="font-bold ">Unsubscribed</p>
                        <div className="progress">
                          <div
                            // style={{ width: this.state.data.unSubscribe }}
                            data-progress={this.state.data.unSubscribe}
                            className="animate-progress"
                          ></div>
                        </div>
                        <p className="font7">
                          From {this.state.fromdate} to {this.state.todate}
                        </p>
                      </div>
                      <div className="audience_count font-bold">
                        {this.state.data.unSubscribe}
                      </div>
                    </li>
                  </ul>
                </div>
              </div>
              <div className="eBox">
                <div className="recent_growth d-flex flex-wrap align-items-center">
                  <div className="icon growth_icon">
                    <span className="icon-tag-black-shape1"></span>
                  </div>
                  <div className="growth_text">
                    <p className="font4">Tags</p>
                    <p className="font7">Your most active Tags.</p>
                  </div>
                </div>
                <div className="tags_outer">
                  <ul>
                    {this.state.tags ? (
                      this.state.tags.length > 0 ? (
                        this.state.tags.slice(0, 4).map((tag, index) => (
                          <li
                            key={index}
                            className="d-flex flex-wrap align-items-center"
                          >
                            <div className="tag_count">
                              <h4>{tag.count}</h4>
                            </div>
                            <p className="font4 tagText">{tag.tag}</p>
                            <a href="">
                              <span className="icon-send1"></span>
                            </a>
                          </li>
                        ))
                      ) : (
                        "No data Available"
                      )
                    ) : (
                      <ContactLoader />
                    )}

                    <li className="more_tags d-flex justify-content-end align-items-start">
                      <a href="/admin/contact/list" className="text_btn">
                        More Tags{" "}
                        <span className="icon-arrow-down-sign-to-navigate"></span>
                        <span className="icon-arrow-down-sign-to-navigate"></span>
                      </a>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </>
    );
  }
}
